// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"oo-z","badgeLink":"po-z","category":"qo-z"};